import { blue, deepOrange, green, orange, red } from '@mui/material/colors';
export const gisFileStatusKeys = ['toDo', 'doing', 'standby', 'done'];
export const gisClientFileTypes = ['CLIENT_ANALYSIS_DOCUMENT', 'CLIENT_INTEGRATION_DOCUMENT'];
export const gisFileTypes = [...gisClientFileTypes, 'ANALYSIS_GUIDELINE', 'ANALYSIS_REPORT', 'INTEGRATION_REPORT'];
export class GISFile {
  constructor(id, title, comment, documentUrl, status, created, creatorId, messages, type, geodataAnalysis) {
    this.id = id;
    this.title = title;
    this.comment = comment;
    this.documentUrl = documentUrl;
    this.status = status;
    this.created = created;
    this.creatorId = creatorId;
    this.messages = messages;
    this.type = type;
    this.geodataAnalysis = geodataAnalysis;
  }
}
export const gisFileStatuses = {
  toDo: {
    titleKey: 'commons.gis_file_statuses.to_do',
    color: deepOrange[500]
  },
  doing: {
    titleKey: 'commons.gis_file_statuses.doing',
    color: blue[500]
  },
  standby: {
    titleKey: 'commons.gis_file_statuses.standby',
    color: orange[500]
  },
  done: {
    titleKey: 'commons.gis_file_statuses.done',
    color: green[500]
  }
};
export const gisFileTypesMap = {
  ANALYSIS_GUIDELINE: {
    titleKey: 'commons.gis_file_types.analysis_guideline'
  },
  ANALYSIS_REPORT: {
    titleKey: 'commons.gis_file_types.analysis_report'
  },
  CLIENT_ANALYSIS_DOCUMENT: {
    titleKey: 'commons.gis_file_types.client_analysis_document'
  },
  INTEGRATION_REPORT: {
    titleKey: 'commons.gis_file_types.integration_report'
  },
  CLIENT_INTEGRATION_DOCUMENT: {
    titleKey: 'commons.gis_file_types.client_integration_document'
  }
};
export class GeodataAnalysis {
  constructor(id, title, description, status, created, updated) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.status = status;
    this.created = created;
    this.updated = updated;
  }
}
export const geodataAnalysisStatuses = {
  WRITING_GUIDELINES: {
    titleKey: 'commons.gis_file_statuses.writing_guidelines',
    color: blue[500]
  },
  WAITING_CLIENT_VALIDATION: {
    titleKey: 'commons.gis_file_statuses.waiting_client_validation',
    color: orange[500]
  },
  VALIDATED_GUIDELINES: {
    titleKey: 'commons.gis_file_statuses.validated_guideline',
    color: orange[500]
  },
  ABANDONED: {
    titleKey: 'commons.gis_file_statuses.adandoned',
    color: red[500]
  },
  WAITING_CLIENT_DATA: {
    titleKey: 'commons.gis_file_statuses.waiting_client_data',
    color: orange[500]
  },
  ONGOING: {
    titleKey: 'commons.gis_file_statuses.ongoing',
    color: blue[500]
  },
  DONE: {
    titleKey: 'commons.gis_file_statuses.done',
    color: green[500]
  }
};